<template>
    <div></div>
</template>

<script>
    import {enum_urlParams} from "../../../functions/src/shareCode/Share_S_Enum";
    import {route_getUrlParams} from "@/router";

    export default {
        name: "v_IframeFailedMsg",
        created(){

            let msg = route_getUrlParams(this.$route, enum_urlParams.msg)

            // send ticketID to parent
            console.log("v_IframeFailedMsg", {msg})
            window.parent.postMessage({msg}, "*");

        },
    }
</script>

<style scoped>

</style>